module.exports = __webpack_public_path__ + "fonts/8f7aa47f37146cea7329c11279bdfa44.svg";